module.exports = __webpack_public_path__ + "img/14-4.3ef2ddc4.png";